import PropTypes from "prop-types"
import { Row, Col } from "antd"
import { Text } from "ui/Typography"
import { numberToCurrency } from "helpers/string"
import { useTranslation } from "react-i18next"

const SummaryKeyValue = ({ details, valueAlign }) => {
  const { t } = useTranslation()
  if (!Array.isArray(details) || details.length === 0) return null
  const isAlignRight = valueAlign === "right"
  return details
    .filter(({ value }) => value !== undefined && value !== null && value !== "")
    .map(({ label, labelKey, count, value, fw }, idx) => {
      const labelText = labelKey ? t(labelKey, { count }) : label
      return (
        <Row key={(labelKey || label || "item") + idx} gutter={[0, 0]}>
          <Col xs={14} md={12}>
            <Text fw={fw || 400}>{labelText}</Text>
          </Col>
          <Col xs={10} md={12} style={{ textAlign: isAlignRight ? "right" : "left" }}>
            <Text fw={fw || 500}>
              {isAlignRight ? "" : "\u00A0\u00A0"}
              {numberToCurrency(value)}
            </Text>
          </Col>
        </Row>
      )
    })
}

SummaryKeyValue.propTypes = {
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      labelKey: PropTypes.string,
      count: PropTypes.number,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      fw: PropTypes.number
    })
  ),
  valueAlign: PropTypes.oneOf(["left", "right"])
}

export default SummaryKeyValue
